export default function ChartsThemesContainerTemplate(data
) {
var out='<div id="themesContainer" class="row col-lg-12 col-md-12 col-sm-12 col-xs-12"> <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12"><input id="chartsType" value="1" class="full-width"/></div></div>';return out;
};